import { render, staticRenderFns } from "./WorkflowQueue.vue?vue&type=template&id=33b35616&"
import script from "./WorkflowQueue.vue?vue&type=script&lang=ts&"
export * from "./WorkflowQueue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports